import { EqlFieldName } from '@modules/common/constants';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { isAggregateFormula } from '@modules/quantify/utils';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

interface useIsSingleRecordQueryParams {
  formulaID?: EQLFunctionName;
}

export function useIsSingleRecordQuery({
  formulaID: formulaIDProp,
}: useIsSingleRecordQueryParams = {}) {
  return useQuantifyStore(({ query }) => {
    const formulaID = formulaIDProp ?? query.formulaQuery?.eqlFunction;
    const field = query.groupByField?.field;

    if (field === EqlFieldName.FeedbackRecords) {
      return true;
    }

    return (
      isAggregateFormula(formulaID) &&
      query.groupByField?.field === query.formulaQuery?.criteria?.field
    );
  });
}
